import { useNavigate } from "react-router-dom";

const PARTNERS = [
  { label: "CUBEMARS", slug: "cubemars" },
  { label: "LAIFUAL", slug: "laifual" },
  { label: "LEADERDRIVE", slug: "leaderdrive" },
  { label: "HOMWING", slug: "howming" },
  { label: "BONSYSTEMS", slug: "bonsystems" },
];

export default function Marquee() {
  const navigate = useNavigate();
  const row = [...PARTNERS, ...PARTNERS, ...PARTNERS];
  return (
    <section id="partners" className="relative border-y border-white/10 bg-ink-2 py-6 overflow-hidden" data-testid="partner-marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((p, i) => (
          <div key={i} className="flex items-center gap-8 px-8">
            <button onClick={() => navigate(`/partners/${p.slug}`)} data-testid={`marquee-${p.slug}-${i}`}
              className="font-head font-extrabold uppercase text-2xl sm:text-3xl tracking-wide text-slate-500 hover:text-signal transition-colors">
              {p.label}
            </button>
            <span className="w-2 h-2 rotate-45 bg-signal/60" />
          </div>
        ))}
      </div>
    </section>
  );
}
